import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import Item from "../Item";
export function pageBuilder(param) {
    var selected = param.selected, totalPages = param.totalPages;
    var pageObjectArray = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Array(totalPages).keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            pageObjectArray.push({
                text: (index + 1).toString(),
                selected: selected === index + 1
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var pageElementArray = [];
    pageObjectArray.forEach(function(page, index) {
        var indexNum = index + 1;
        if (selected <= 7 && totalPages <= 7) {
            pageElementArray.push(_jsx(Item, {
                text: page.text,
                selected: page.selected
            }, page.text));
        }
        if (selected <= 4 && totalPages > 7) {
            if (indexNum <= 5 || indexNum === totalPages) {
                pageElementArray.push(_jsx(Item, {
                    text: page.text,
                    selected: page.selected
                }, page.text));
            }
            if (indexNum === 6) {
                pageElementArray.push(_jsx(Item, {
                    text: "...",
                    disabled: true
                }, indexNum));
            }
        }
        if (selected >= totalPages - 3 && totalPages > 7) {
            if (indexNum === 1) {
                pageElementArray.push(_jsx(Item, {
                    text: page.text,
                    selected: page.selected
                }, page.text));
            }
            if (indexNum === 2) {
                pageElementArray.push(_jsx(Item, {
                    text: "...",
                    disabled: true
                }, page.text));
            }
            if (indexNum >= totalPages - 4) {
                pageElementArray.push(_jsx(Item, {
                    text: page.text,
                    selected: page.selected
                }, page.text));
            }
        }
        if (selected >= 5 && selected <= totalPages - 4 && totalPages > 7) {
            if (indexNum === 1) {
                pageElementArray.push(_jsx(Item, {
                    text: page.text,
                    selected: page.selected
                }, page.text));
            }
            if (indexNum === 2) {
                pageElementArray.push(_jsx(Item, {
                    text: "...",
                    disabled: true
                }, page.text));
            }
            if (indexNum === selected - 1 || indexNum === selected || indexNum === selected + 1) {
                pageElementArray.push(_jsx(Item, {
                    text: page.text,
                    selected: page.selected
                }, page.text));
            }
            if (indexNum === totalPages - 1) {
                pageElementArray.push(_jsx(Item, {
                    text: "...",
                    disabled: true
                }, page.text));
            }
            if (indexNum === totalPages) {
                pageElementArray.push(_jsx(Item, {
                    text: page.text,
                    selected: page.selected
                }, page.text));
            }
        }
    });
    return pageElementArray;
}
